import { createAsyncThunk } from '@reduxjs/toolkit';
import { getVerificationSettings } from 'services/verificationSettings';
import { IVerificationSettings } from 'services/verificationSettings/types';

export const ThunkGetVerificationSettings = createAsyncThunk<IVerificationSettings>(
  'verificationSettings/getVerificationSettings',
  () => getVerificationSettings().then(r => r.data),
);
